<template>
  <div class="profile-item">
    <i :class="icon"> </i>
    <div v-if="name" class="name">{{ name }} :</div>
    <div class="text" :class="{ bold: name }">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'profile-item',

  props: {
    icon: {
      type: String,
      require: false,
      default: '',
    },
    name: {
      type: String,
      require: false,
      default: '',
    },
    text: {
      type: String,
      require: true,
      default: '',
    },
  },
}
</script>

<style scoped></style>
